import { useContextTS } from "@inrange/utils";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { SiteCalculationsContext } from "../../../shared-components/src/SiteCalculationsContext";
import {
  formatNumber,
  parseAsNumber,
  roundToDp,
} from "./site/siteSections/utils";

const FormInputPercentage = ({
  value,
  onChange,
  disabled,
  errorKey,
  testId,
}: {
  value: string | number;
  onChange: (e: { target: { value: string } }) => void;
  disabled?: boolean;
  errorKey: string;
  testId?: string;
}) => {
  const { errors, clientsideValidations } = useContextTS(
    SiteCalculationsContext
  );
  const [input, setInput] = useState<string>(
    value === "" || value === undefined
      ? ""
      : formatNumber(parseAsNumber(value) * 100, 1, 8, false)
  );
  const inputRef = useRef<string | undefined>(undefined);
  inputRef.current = input;
  useEffect(() => {
    if (value === "" || value === undefined) {
      if (inputRef.current !== "") {
        // Sync input with empty string from value prop
        setInput("");
      }
    } else {
      const parsedValue = parseAsNumber(value);
      const parsedInput = parseAsNumber(inputRef.current);
      if (
        !isNaN(parsedValue) &&
        !isNaN(parsedInput) &&
        roundToDp(parsedValue, 8) !== roundToDp(parsedInput / 100, 8)
      ) {
        // Value prop is a different number vs the current rounded input, so sync
        setInput(formatNumber(parsedValue * 100, 1, 8, false));
      } else if (isNaN(parsedValue)) {
        // Value prop is not a number, so sync input with raw value
        setInput(`${value}`);
      }
    }
  }, [value]);

  const handleChange = (e) => {
    setInput(e.target.value);
    const num = parseFloat(e.target.value);
    if (!isNaN(num)) {
      onChange({ target: { value: (num / 100).toString() } });
    } else {
      onChange({ target: { value: e.target.value } });
    }
  };
  return (
    <>
      <Form.Control
        type="text"
        value={input}
        onChange={handleChange}
        disabled={disabled}
        isInvalid={!!errors[errorKey] || !!clientsideValidations[errorKey]}
        data-testid={testId}
      />
      {(!!errors[errorKey] || !!clientsideValidations[errorKey]) && (
        <Form.Control.Feedback type="invalid">
          {errors[errorKey] || clientsideValidations[errorKey]}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default FormInputPercentage;
